// Helper to select a project after login and navigate to its overview.
// Iterates projects, preferring the latest first, to find one with procuring entities.
// If none of the projects have procuring entities, redirect to the Exceptions page
// within the context of a project (using the latest project id when available).
export function selectProjectAndRedirect(projects, history, setActiveProject) {
  if (!Array.isArray(projects) || projects.length === 0) {
    history.push("/");
    return false;
  }

  // Prefer latest to earliest: iterate from end to start
  const ordered = [...projects];
  // Guard against non-array-like issues
  const len = ordered.length;
  let selectedWithPE = null;
  for (let i = len - 1; i >= 0; i--) {
    const proj = ordered[i];
    const peId = proj?.procuring_entities?.[0]?.procuring_entity_id;
    if (proj?.id != null && peId != null) {
      selectedWithPE = { projectId: proj.id, procuringEntityId: peId };
      break;
    }
  }

  if (selectedWithPE) {
    const { projectId, procuringEntityId } = selectedWithPE;
    if (typeof setActiveProject === "function") {
      setActiveProject(projectId, procuringEntityId);
    } else {
  // No context setter available; skip persistence and just navigate.
    }
    if (history.location?.pathname !== `/project/${projectId}/overview`) {
      history.push(`/project/${projectId}/overview`);
    }
    return true;
  }

  // No projects with procuring entities: redirect to Exceptions page.
  const fallbackProject = ordered[len - 1] || ordered[0];
  const fallbackProjectId = fallbackProject?.id;
  if (fallbackProjectId != null) {
    if (history.location?.pathname !== `/exceptions`) {
      history.push(`/exceptions`);
    }
    return true;
  }

  // As a last resort, go home
  history.push("/");
  return false;
}
